import script from "./Employee.vue?vue&type=script&setup=true&lang=js"
export * from "./Employee.vue?vue&type=script&setup=true&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=43f5338f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f5338f"]])

export default __exports__